import type { IFilterTag } from '../types';
import type { IArrayFilterConfig } from '../configs';

const getArrayTags = <TFilters>(configs: IArrayFilterConfig<TFilters>[], filters: TFilters): IFilterTag[] =>
  configs.flatMap(({ key, label, pluralLabel, isExclude = false, removable = true }) => {
    const value = filters[key] as (string | number)[];
    if (!value?.length) return [];
    const displayLabel = value.length > 1 && pluralLabel ? pluralLabel : label;
    return [{ key: key as string, label: `${ value.length } ${ displayLabel }`, isExclude, removable }];
  });

export default getArrayTags;
